import {
  GSS_PRODUCT_ID,
  GSU_PRODUCT_ID,
  WSS_PRODUCT_ID,
} from "@/utils/helpers/mappings"
import { LinkResourceResponse } from "@/types/LinkApi"
import { ProductNumber } from "@/types/General"

interface Premium {
  amount: number
  premiumType: string
}

export interface InsuranceBenefit {
  premiums: Premium[]
  cover: number
  benefitName: string
  waitingPeriod: {
    code: string
    description: null | string
  }
}

export interface Insurance {
  paidToDate: string
  effectiveDate: string
  endDate: string
  nextDebitDate: string
  policyBenefits: InsuranceBenefit[]
  policyId: number
}

export interface InsuranceResp {
  insurances: Insurance[]
}

export type InsuranceRateResp = LinkResourceResponse<{
  rate: number
}>

export type InsuranceProductIds =
  | typeof GSS_PRODUCT_ID
  | typeof WSS_PRODUCT_ID
  | typeof GSU_PRODUCT_ID

export type InsuranceSpecialField = {
  fieldCode: string
  fieldName: string
  value: {
    code: string
    description: string
  }
}

export type InsuranceSpecialFieldsResp = LinkResourceResponse<{
  specialFields: InsuranceSpecialField[]
}>

export function isInsuredProductId(
  id: ProductNumber
): id is InsuranceProductIds {
  return [GSS_PRODUCT_ID, WSS_PRODUCT_ID, GSU_PRODUCT_ID].includes(id)
}

export type InsuranceRatesQuery = {
  fetch: boolean
  params: {
    age: string
    premiumType: string
    gender?: "M" | "F"
  }
  key:
    | "deathRate"
    | "deathAndTpdRate"
    | "sciRate"
    | "occCatLoadDeathAndTpd"
    | "occCatLoadSci"
    | "waitingPeriodRate"
}

export type InsuranceRatesResponse = Record<InsuranceRatesQuery["key"], number>

export type InsuranceVariationPayload = {
  deathTpdPolicyNo?: number | null
  /**
   * Formatted as Y-m-d
   */
  effectiveDate?: string
  fixedAgeBasedCover?: boolean
  occupationCategory?: string
  occupationDescription?: string
  optOutDeathTpd?: boolean
  /**
   * Ignore the api docs. This is indeed optOutSciFiend
   */
  optOutSciFiend?: boolean
  sciPolicyNo?: number | null
  sciWaitingPeriod?: number | null
  sumInsuredDeath?: number | null
  sumInsuredSci?: number | null
  sumInsuredTpd?: number | null
}

export type BalanceDetails = {
  data: {
    resource: {
      averageContributionRate: number
      finalRemuneration: number
    }
  }
  isFetching: boolean
  isError: boolean
}
